<template>
  <div class="container">
    <el-dialog title="消息列表" :show-close=false lock-scroll fullscreen :visible="dialogFormVisible">
    <el-form :model="form">
      <el-input placeholder="请输入内容" v-model="form.search" class="input-with-select">
        <el-button slot="append" @click="searchcon" icon="el-icon-search"></el-button>
      </el-input>
      <el-form-item label="" label-width="100">
        <el-checkbox-group
          v-model="form.checkeds">
          <el-checkbox style="display:block;padding:5px;" v-for="(item,index) in replyList" v-if="item.content.length>200" :label="item.attachment" :value="item.attachment" :key="index"><img :src="item.content" width="100px" height="80px" alt="图片丢失"/></el-checkbox>
          <el-checkbox style="display:block;padding:5px;" v-for="(item,index) in replyList" v-if="item.content.length<=200" :label="item.content" :value="item.content" :key="index"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align:center">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitInfo">确 定</el-button>
    </div>
  </el-dialog>
    <el-row>
      <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" inlineMessage status-icon :model="relatedInfo">
        <el-form-item label="DLR情报质量" prop="dlrQuality" @change.native="changes">
          <el-radio v-model="relatedInfo.dlrQuality" :disabled="disabled||lishi" :label="relatedInfo.dlrQualityOption[0]" :value="relatedInfo.dlrQualityOption[0]" border size="medium"></el-radio>
          <el-radio v-model="relatedInfo.dlrQuality" :disabled="disabled||lishi" :label="relatedInfo.dlrQualityOption[1]" :value="relatedInfo.dlrQualityOption[1]" border size="medium"></el-radio>
          <el-radio :disabled="lishi" v-model="relatedInfo.dlrQuality" :label="relatedInfo.dlrQualityOption[2]" :value="relatedInfo.dlrQualityOption[2]" border size="medium">{{relatedInfo.dlrQualityOption[2]}}【退回】处理</el-radio>
          <!-- <el-button type="primary" size="small" @click="adsubmit" v-show="user.type == 1 && relatedInfo.status == '未处理' && relatedInfo.dlrQuality != relatedInfo.dlrQualityOption[2]">通知DLR</el-button> -->
        </el-form-item>
        <el-form-item label="追加资料" prop="firstContent" v-if="relatedInfo.dlrQuality == relatedInfo.dlrQualityOption[1]">
          <el-input :disabled="lishi" type="textarea" v-model="relatedInfo.firstContent"></el-input>
        </el-form-item>
        <el-form-item label="退回原因" prop="backReason" v-if=" relatedInfo.dlrQuality == relatedInfo.dlrQualityOption[2]">
          <el-input :disabled="lishi" type="textarea" v-model="relatedInfo.backReason"></el-input>
        </el-form-item>
        <el-form-item label="案件重要度" prop="casePriority" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]">
          <el-radio :disabled="lishi" v-model="relatedInfo.casePriority" :label="relatedInfo.casePriorityOption[0]" :value="relatedInfo.casePriorityOption[0]" border size="medium"></el-radio>
          <el-radio :disabled="lishi" v-model="relatedInfo.casePriority" :label="relatedInfo.casePriorityOption[1]" :value="relatedInfo.casePriorityOption[1]" border size="medium"></el-radio>
          <el-radio :disabled="lishi" v-model="relatedInfo.casePriority" :label="relatedInfo.casePriorityOption[2]" :value="relatedInfo.casePriorityOption[2]" border size="medium"></el-radio>
          <el-radio :disabled="lishi" v-model="relatedInfo.casePriority" :label="relatedInfo.casePriorityOption[3]" :value="relatedInfo.casePriorityOption[3]" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="案件难易度" prop="difficulty" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]">
          <el-radio :disabled="lishi" v-model="relatedInfo.difficulty[0]" v-for="(item,index) in relatedInfo.difficultyOption" :key="index" :label="item" :value="item" border size="medium"></el-radio>
          <!-- <el-radio v-model="relatedInfo.difficulty[0]" :label="relatedInfo.difficultyOption[1]" :value="relatedInfo.difficultyOption[1]" border size="medium"></el-radio>
          <el-radio v-model="relatedInfo.difficulty[0]" :label="relatedInfo.difficultyOption[2]" :value="relatedInfo.difficultyOption[2]" border size="medium"></el-radio> -->
        </el-form-item>
        <!-- <el-form-item style="text-align: left">
          <el-button type="primary" @click.native="first">确定</el-button>
        </el-form-item> -->
        <el-form-item label="对应方向" prop="direction" v-if="relatedInfo.saveStep&&relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]">
          <!-- <el-checkbox size="medium" v-model="relatedInfo.directions" value="远程指导" label="远程指导" border></el-checkbox> -->
          <el-checkbox size="medium" :disabled="lishi" @change="direction($event)" v-model="relatedInfo.directions" v-for="item in relatedInfo.directionOption" :value="item" :key="item" :label="item" border></el-checkbox>
        </el-form-item>
        <el-form-item label="预计现认时间" prop="preRecognitionDate"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认')&&!relatedInfo.recognitionReason && relatedInfo.saveStep>1">
          <el-date-picker
            v-model="relatedInfo.preRecognitionDate"
            type="date"
            :disabled="!!relatedInfo.recognitionReason||lishi"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="现认时间" prop="recognitionDate"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认')&&!relatedInfo.recognitionReason && relatedInfo.saveStep>2">
          <el-date-picker
            v-model="relatedInfo.recognitionDate"
            type="date"
            :disabled="!!relatedInfo.recognitionReason||lishi"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="未现认理由" prop="recognitionReason"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认')&&!relatedInfo.recognitionDate && relatedInfo.saveStep>2">
          <el-input type="textarea" v-model="relatedInfo.recognitionReason" :disabled="!!relatedInfo.recognitionDate||lishi"></el-input>
        </el-form-item>
        <el-form-item label="RSR发行时间" prop="rsrReleaseTime"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == 'RSR发行'||relatedInfo.directions[1] == 'RSR发行')&&!relatedInfo.rsrReleaseReason && relatedInfo.saveStep>1">
          <el-date-picker
            v-model="relatedInfo.rsrReleaseTime"
            type="date"
            :disabled="lishi"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="RSR未发行理由" prop="rsrReleaseReason" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == 'RSR发行'||relatedInfo.directions[1] == 'RSR发行')&&!relatedInfo.rsrReleaseTime && relatedInfo.saveStep>2">
          <el-input type="textarea" v-model="relatedInfo.rsrReleaseReason"  :disabled="!!relatedInfo.rsrReleaseTime || lishi"></el-input>
        </el-form-item>
        <el-form-item label="RS入手时间" prop="rscStartTime" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == 'RSR发行'||relatedInfo.directions[1] == 'RSR发行')&&relatedInfo.rsrReleaseTime && relatedInfo.saveStep>2">
          <el-date-picker
            v-model="relatedInfo.rscStartTime"
            type="date"
            :disabled="lishi"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="RS入手时间" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == 'RSR发行'||relatedInfo.directions[1] == 'RSR发行')&&!relatedInfo.rsrReleaseTime && relatedInfo.saveStep>2">
          <el-date-picker
            v-model="relatedInfo.rscStartTime"
            type="date"
            :disabled="lishi"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="最终对应方案" prop="finalSolution" style="position:relative"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] != '现认'&&relatedInfo.directions[1] != '现认')&&(relatedInfo.directions[0] != 'RSR发行'&&relatedInfo.directions[1] != 'RSR发行') && relatedInfo.saveStep&&relatedInfo.saveStep>1">
          <el-button :disabled="lishi" type="primary" @click.native="selectsearch" size="mini" style="cursor:pointer;position:absolute;top:-30px;right:0">选择按钮</el-button>
          <el-input  :disabled="lishi" v-model="relatedInfo.finalSolution"></el-input>
        </el-form-item>
        <el-form-item label="最终对应方案" prop="finalSolution" style="position:relative"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认'|| relatedInfo.directions[0] == 'RSR发行'||relatedInfo.directions[1] == 'RSR发行') &&relatedInfo.saveStep&&relatedInfo.saveStep>3">
          <el-button  :disabled="lishi" type="primary" @click.native="selectsearch" size="mini" style="cursor:pointer;position:absolute;top:-30px;right:0">选择按钮</el-button>
          <el-input :disabled="lishi"  v-model="relatedInfo.finalSolution"></el-input>
        </el-form-item>
        <el-form-item label="现象分类" prop="phenomenonsTmci" style="position:relative"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] != '现认'&&relatedInfo.directions[1] != '现认')&&(relatedInfo.directions[0] != 'RSR发行'&&relatedInfo.directions[1] != 'RSR发行') && relatedInfo.saveStep&&relatedInfo.saveStep>1">
          <el-select  :disabled="lishi" multiple v-model="relatedInfo.phenomenonsTmci" placeholder="请选择">
            <el-option
              v-for="item in relatedInfo.phenomenonTmciOption"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现象分类" prop="phenomenonsTmci" style="position:relative"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认'|| relatedInfo.directions[0] == 'RSR发行'||relatedInfo.directions[1] == 'RSR发行') &&relatedInfo.saveStep&&relatedInfo.saveStep>3">
          <el-select  :disabled="lishi" multiple v-model="relatedInfo.phenomenonsTmci" placeholder="请选择">
            <el-option
              v-for="item in relatedInfo.phenomenonTmciOption"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="技术现认报告书编号" prop="reportNo" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认') && relatedInfo.saveStep>4">
          <el-input  v-model="relatedInfo.reportNo"></el-input>
        </el-form-item>
        <el-form-item label="技术现认报告书发行日期" prop="reportNoDates" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&(relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认') && relatedInfo.saveStep>4">
          <el-date-picker
            v-model="relatedInfo.reportNoDates"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="支援报告书编号" prop="reportSupportNo" v-if="relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认'">
          <el-input  v-model="relatedInfo.reportSupportNo"></el-input>
        </el-form-item>
        <el-form-item label="支援报告书发行日期" prop="reportSupportNoDates" v-if="relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认'">
          <el-date-picker
            v-model="relatedInfo.reportSupportNoDates"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="跟进必要性"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&relatedInfo.directions.includes('现认')&&relatedInfo.saveStep&&relatedInfo.saveStep>5">
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[0]" :value="relatedInfo.followupOption[0]" border size="medium"></el-radio>
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[1]" :value="relatedInfo.followupOption[1]" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="跟进必要性"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&relatedInfo.directions.includes('RSR发行')&&!relatedInfo.directions.includes('现认')&&relatedInfo.saveStep&&relatedInfo.saveStep>4">
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[0]" :value="relatedInfo.followupOption[0]" border size="medium"></el-radio>
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[1]" :value="relatedInfo.followupOption[1]" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="跟进必要性"  v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&!relatedInfo.directions.includes('现认')&&!relatedInfo.directions.includes('RSR发行') && relatedInfo.saveStep&&relatedInfo.saveStep>2">
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[0]" :value="relatedInfo.followupOption[0]" border size="medium"></el-radio>
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[1]" :value="relatedInfo.followupOption[1]" border size="medium"></el-radio>
        </el-form-item>
        <!-- <el-form-item label="跟进必要性"  v-if="(relatedInfo.directions[0] == '现认'||relatedInfo.directions[1] == '现认')&&relatedInfo.saveStep&&relatedInfo.saveStep>5">
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[0]" :value="relatedInfo.followupOption[0]" border size="medium"></el-radio>
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[1]" :value="relatedInfo.followupOption[1]" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="跟进必要性"  v-if="(relatedInfo.directions[0] == 'RSR发行'||relatedInfo.directions[1] == 'RSR发行')&&(relatedInfo.directions[0] != '现认'||relatedInfo.directions[1] != '现认')&&relatedInfo.saveStep&&relatedInfo.saveStep>4">
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[0]" :value="relatedInfo.followupOption[0]" border size="medium"></el-radio>
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[1]" :value="relatedInfo.followupOption[1]" border size="medium"></el-radio>
        </el-form-item>
        <el-form-item label="跟进必要性"  v-if="(relatedInfo.directions[0] != '现认'&&relatedInfo.directions[1] != '现认')&&(relatedInfo.directions[0] != 'RSR发行'&&relatedInfo.directions[1] != 'RSR发行') && relatedInfo.saveStep&&relatedInfo.saveStep>2">
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[0]" :value="relatedInfo.followupOption[0]" border size="medium"></el-radio>
          <el-radio v-model="relatedInfo.followup" :label="relatedInfo.followupOption[1]" :value="relatedInfo.followupOption[1]" border size="medium"></el-radio>
        </el-form-item> -->
        <el-form-item label="跟进必要性填写内容" prop="followupContent" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&relatedInfo.followup == '有'">
          <el-input type="textarea"  v-model="relatedInfo.followupContent"></el-input>
        </el-form-item>
        <el-form-item label="跟进方向" prop="followupDirection" v-if="relatedInfo.dlrQuality!=relatedInfo.dlrQualityOption[2]&&relatedInfo.followup == '有'">
          <el-input  v-model="relatedInfo.followupDirection"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="info" @click.native="cancels()">取消</el-button>
          <el-button type="primary" :disabled="sub" @click.native="onSubmit">确认</el-button>
          <el-button type="success" :disabled="sub" @click.native="onSave">保存</el-button>
          <el-badge :value="relatedInfo.unreadCount?relatedInfo.unreadCount:''">
            <el-button style="background:#00ae66;color:#fff;margin-left:10px" @click="chat($route.params.id)">消息</el-button>
          </el-badge>
        </el-form-item>
      </el-form>
    </el-row>

  </div>

</template>

<script>
import addCase, { getDefaultData, tmciSubmit, updateCase, getReplyList, getImg } from '@/api/alarmCase.js'
import { getOptions } from '@/api/export.js'
import axios from '@/utils/api.request'
import { Toast, MessageBox } from 'mint-ui'
export default {
  name: 'addCase',
  data () {
    return {
      dialogFormVisible: false,
      unreadCount: null,
      form: { checkeds: [] },
      relatedInfo: {
        id: 0,
        firstDate: '', // 初次答复时间
        dlrQuality: [], // DLR情报质量
        difficulty: [], // 案件难易度
        directions: [], // 对应方向
        directionDateDistance: '', // 对应方向确定时间
        recognitionDate: '', // 现认时间
        preRecognitionDate: '',
        firstContent: '', // 初次答复内容
        firstDateDistance: '', // 初次答复经过时间（d-w ）
        recognitionReason: '', // 现认时间理由
        rsrReleaseTime: '', // RSR发行时间
        rsrReleaseReason: '', // RSR发行时间理由
        rscStartTime: '', // RSC入手时间
        casePriority: '', // 案件重要度
        backReason: '', // 退回原因
        reportNo: '', // 技术现认报告书编号
        reportSupportNo: '', // 支援报告书编号
        followup: '', // 跟进必要性
        followupContent: '', // 跟进必要性填写内容
        followupDirection: '',
        reportNoDates: '', // 技术现认报告书发行日期
        reportSupportNoDates: '', // 支援报告书发行日期
        finalSolution: '',
        phenomenonsTmci: '',
        difficultyOption: [],
        casePriorityOption: [],
        followupOption: [],
        directionOption: [],
        dlrQualityOption: [],
        phenomenonTmciOption: []
      },
      getOptions: [],
      rules: {
        dlrQuality: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        difficulty: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        firstContent: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        backReason: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        firstDateDistance: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        recognitionReason: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        casePriority: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        recognitionDate: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        preRecognitionDate: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        rscStartTime: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        rsrReleaseTime: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        rsrReleaseReason: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        firstDate: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        directionDateDistance: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        followupContent: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        followupDirection: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        followup: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        finalSolution: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        phenomenonsTmci: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        reportSupportNoDates: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        reportNoDates: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        reportSupportNo: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        direction: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ],
        reportNo: [
          { required: true, message: '该项不能为空', trigger: 'change' }
        ]
      },
      attachmentIdss: [],
      phenomenonIdsArr: [], // 现象分类
      partIdsArr: [], // 现象分类表示名称
      sub: false,
      user: [],
      fileList: [],
      replyList: [
      ],
      disabled: false,
      lishi: false
    }
  },
  created () {
    console.log(this.relatedInfo.recognitionDate.length)
    this.user = JSON.parse(localStorage.getItem('user'))
    this.relatedInfo.type = this.user.type
    this.relatedInfo.dealerName = this.user.typeName
    var ids
    if (this.$route.params.id && this.$route.params.id > 0) {
      ids = this.$route.params.id
      this.relatedInfo.id = ids
      getDefaultData(ids).then(res => {
        this.relatedInfo = res.data
        if (this.relatedInfo.statusDisplay === '已退回' || this.relatedInfo.statusDisplay === '退回') {
          this.disabled = true
        }
        if (this.relatedInfo.statusDisplay === '结案') {
          this.lishi = true
        }
        console.log(this.relatedInfo.difficultyOption)
      })
    }
    this.getReplyList(this.$route.params.id)
  },
  methods: {
    direction () {
      if (this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[0]) == 0 && (this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[1]) >= 0 || this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[2]) >= 0)) {
        console.log(this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[0]))
        if (this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[0]) >= 0) {
          this.relatedInfo.directions.splice(this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[0]), 1)
        }
      } else if (this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[0]) > 0) {
        if (this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[1]) >= 0) {
          this.relatedInfo.directions.splice(this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[1]), 1)
        }
        if (this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[2]) >= 0) {
          this.relatedInfo.directions.splice(this.relatedInfo.directions.indexOf(this.relatedInfo.directionOption[2]), 1)
        }
      }
    },
    chat (e) {
      var status = 1
      this.$router.push({ path: '/newsChat/' + status + '/' + e })
    },
    searchcon () {
      this.getReplyList(this.$route.params.id)
    },
    submitInfo () {
      console.log(this.form.checkeds)
      this.dialogFormVisible = false
      this.relatedInfo.finalSolution = this.form.checkeds.join(',')
    },
    getReplyList (id) {
      getReplyList(id, this.form.search).then((res) => {
        this.replyList = res.data
        this.replyList.forEach(v => {
          if (v.content && v.content.indexOf('attachments/') > -1) {
            getImg(v.content).then(resp => {
              var mimeType = 'image/jpeg'
              var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
              v.attachment = v.content
              v.content = 'data:' + mimeType + ';base64,' + imgBase64
            })
          }
        })
        console.log(this.replyList)
      })
    },
    cancels () {
      this.$router.go(-1)
    },
    selectsearch () {
      this.dialogFormVisible = true
    },
    onSave () {
      if (this.relatedInfo.statusDisplay === '已退回' || this.relatedInfo.statusDisplay === '退回') {
        Toast({
          message: '已退回案件无法保存',
          iconClass: 'icon el-icon-close'
        })
        return
      }
      this.relatedInfo.attachmentIds = []
      this.attachmentIdss.forEach((v, i) => {
        this.relatedInfo.attachmentIds.push(v.id)
      })

      updateCase(this.relatedInfo.id, this.relatedInfo).then(res => {
        if (res.data.success) {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.$router.push('/case')
        } else {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
      this.sub = true
      setTimeout(() => {
        this.sub = false
      }, 3000)
    },
    changes () {
      if (this.relatedInfo.dlrQuality == this.relatedInfo.dlrQualityOption[2]) {
        this.rules = {
          dlrQuality: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          backReason: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ]
        }
      } else {
        this.rules = {
          dlrQuality: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          difficulty: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          firstContent: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          backReason: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          firstDateDistance: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          recognitionReason: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          casePriority: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          recognitionDate: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          preRecognitionDate: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          rscStartTime: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          rsrReleaseTime: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          rsrReleaseReason: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          firstDate: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          directionDateDistance: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          followupContent: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          followupDirection: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          followup: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          finalSolution: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          reportSupportNoDates: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          reportNoDates: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          reportSupportNo: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          reportNo: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ]
        }
      }
    },
    adsubmit () {
      console.log(this.relatedInfo.statusDisplay)
      if (this.relatedInfo.statusDisplay === '已退回' || this.relatedInfo.statusDisplay === '退回') {
        Toast({
          message: '已退回案件无法重复提交',
          iconClass: 'icon el-icon-close'
        })
        return
      }
      if (this.relatedInfo.directions.length < 1) {
        Toast({
          message: '对应方向不能为空',
          iconClass: 'icon el-icon-close'
        })
      }
      MessageBox.confirm('', {
        title: '提示',
        message: '提交后无法撤回，确认提交?',
        showCancelButton: true
      }).then(() => {
        this.relatedInfo.attachmentIds = []
        this.attachmentIdss.forEach((v, i) => {
          this.relatedInfo.attachmentIds.push(v.id)
        })
        tmciSubmit(this.relatedInfo).then((res) => {
          if (res.data.success) {
            Toast({
              message: res.data.msg,
              iconClass: 'icon el-icon-check'
            })
          } else {
            Toast({
              message: res.data.msg,
              iconClass: 'icon el-icon-close'
            })
          }
        })
        this.sub = true
        setTimeout(() => {
          this.sub = false
        }, 3000)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        })
      })
    },
    firstRule () {
      if (this.relatedInfo.dlrQuality == this.relatedInfo.dlrQualityOption[2]) {
        this.rules = {
          dlrQuality: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          backReason: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ]
        }
      } else {
        this.rules = {
          dlrQuality: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          difficulty: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ],
          casePriority: [
            { required: true, message: '该项不能为空', trigger: 'change' }
          ]
        }
      }
    },

    first () {
      this.firstRule()
      var _this = this
      if (this.relatedInfo.directions.length < 1) {
        Toast({
          message: '对应方向不能为空',
          iconClass: 'icon el-icon-close'
        })
      }
      window.setTimeout(function () {
        _this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            MessageBox.confirm('', {
              title: '提示',
              message: '提交后无法撤回，确认提交?',
              showCancelButton: true
            }).then(() => {
              _this.relatedInfo.attachmentIds = []
              _this.attachmentIdss.forEach((v, i) => {
                _this.relatedInfo.attachmentIds.push(v.id)
              })
              tmciSubmit(_this.relatedInfo).then((res) => {
                if (res.data.success) {
                  Toast({
                    message: res.data.msg,
                    iconClass: 'icon el-icon-check'
                  })
                  // _this.$router.push('/case')
                } else {
                  Toast({
                    message: res.data.msg,
                    iconClass: 'icon el-icon-close'
                  })
                }
              })
              _this.sub = true
              setTimeout(() => {
                _this.sub = false
              }, 3000)
            }).catch(() => {
              _this.$message({
                type: 'info',
                message: '已取消提交'
              })
            })
          }
        })
      }, 100)
    },
    onSubmit () {
      this.changes()
      console.log(this.relatedInfo.statusDisplay)
      if (this.relatedInfo.statusDisplay === '已退回' || this.relatedInfo.statusDisplay === '退回') {
        Toast({
          message: '已退回案件无法重复提交',
          iconClass: 'icon el-icon-close'
        })
        return
      }
      console.log(this.relatedInfo.directions)
      if (this.relatedInfo.directions.length < 1) {
        Toast({
          message: '对应方向不能为空',
          iconClass: 'icon el-icon-close'
        })
        return
      }
      var _this = this
      window.setTimeout(function () {
        _this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            MessageBox.confirm('', {
              title: '提示',
              message: '提交后无法撤回，确认提交?',
              showCancelButton: true
            }).then(() => {
              if (_this.relatedInfo.saveStep) {
                _this.relatedInfo.saveStep += 1
              } else {
                _this.relatedInfo.saveStep = 1
              }
              console.log(_this.relatedInfo)
              _this.relatedInfo.attachmentIds = []
              _this.attachmentIdss.forEach((v, i) => {
                _this.relatedInfo.attachmentIds.push(v.id)
              })
              tmciSubmit(_this.relatedInfo).then((res) => {
                if (res.data.success) {
                  Toast({
                    message: res.data.msg,
                    iconClass: 'icon el-icon-check'
                  })
                  // _this.$router.push('/case')
                } else {
                  Toast({
                    message: res.data.msg,
                    iconClass: 'icon el-icon-close'
                  })
                }
              })
              _this.sub = true
              setTimeout(() => {
                _this.sub = false
              }, 3000)
            }).catch(() => {
              _this.$message({
                type: 'info',
                message: '已取消提交'
              })
            })
          }
        })
      }, 100)
    }
  }
}
</script>

<style scoped>
  .container {
    max-width: 500px;
    margin: auto;
    padding: 0 0.32rem;
    background: #fff;
  }
  .el-col, .el-col-18 {
    height:0.3rem;
    line-height: 0.4rem;
  }
  .el-col {
    padding: 0 0.1rem;
  }
  .header {
    padding-bottom: 0.15rem;
    border-bottom: 1px solid blue;
  }
  .el-form-item {
    text-align: left;
    margin: 0.1rem 0;
  }
  .el-form-item__label,.el-form-item__content {
    line-height: 0.4rem;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-input__icon {
    height: auto;
  }
  .el-row {
    margin-bottom: 0.1rem;
  }
  .el-radio.is-bordered+.el-radio.is-bordered {
    margin-left: 0;
  }
  .el-radio{
    margin-right: 3%;
    margin-bottom: 15px;
  }
  .el-checkbox{
    margin-right: 1%;
    margin-bottom: 15px;
  }
</style>
